import { clone, isObject } from "@swa-ui/object";

export const applyUrlOverrides = (placementsObject = {}, hrefBasePath = "") => {
  const updatedPlacements = clone(placementsObject);

  return Object.entries(updatedPlacements).reduce(
    (processedPlacements, [placementId, placement]) => {
      if (placement?.content) {
        processedPlacements[placementId] = {
          ...placement,
          content: processContent(placement.content),
        };
      } else {
        processedPlacements[placementId] = placement;
      }

      return processedPlacements;
    },
    {}
  );

  function processContent(content) {
    let processedContent = content;

    if (Array.isArray(content)) {
      processedContent = content.map((item) => processContent(item));
    } else if (isObject(content)) {
      processedContent = Object.entries(content).reduce(
        (accumulatedContent, [contentKey, contentValue]) => {
          if (typeof contentValue === "string" && contentValue.startsWith("/")) {
            accumulatedContent[contentKey] = `${hrefBasePath}/${contentValue.replace(/^\//, "")}`;
          } else {
            accumulatedContent[contentKey] = processContent(contentValue);
          }

          return accumulatedContent;
        },
        {}
      );
    }

    return processedContent;
  }
};
